export default __webpack_public_path__ + "static/980-68748e6e246afd1b46544baa961394e0.gif";